import { FormTranslation } from '@/assets/locales/form/form.translation.en';
import { groupSelectWithRegionsTranslation } from '@/assets/locales/form/GroupSelectWithRegions/GroupSelectWithRegions.translation.pl';

export const formTranslation: FormTranslation = {
  dateFormField: {
    chooseDate: 'Wybierz datę',
  },
  groupSelectWithRegions: groupSelectWithRegionsTranslation,
  selectAll: 'Zaznacz wszystkie',
};
